/* eslint-disable no-shadow */
export interface ImagemCartao {
  id: number
  descricao: string
  arquivoNomeOriginal: string
  arquivoNomeGerado: string
  idImagemCartaoDock: number
  produtos: Produto[]
  ativo: boolean
  dataAlteracao: Date
  dataCriacao: Date
}

export interface Produto {
  id: number
  nome: string
  idProdutoDock: number
  idOrigemComercialDock: number
  idTipoCartao: number
  idEndereco: number
  imagemCartao: ImagemCartao
  regras: string
  taxaSegundaVia: number
  ativo: boolean
  dataAlteracao: Date
  dataCriacao: Date
}

export interface PessoaFisica {
  id: number
  nome: string
  cpf: string
  ativo: boolean
  idPessoaDock: number
  idRegistrationDock: string
}

export interface PessoaJuridica {
  id: number
  cnpj: string
  razaoSocial: string
  nomeFantasia: string
  inscricaoEstadual: string
  dataAbertura: Date
  idRegistrationDock: string
  idCompanyDock: string
  ativo: boolean
}

export interface Pessoa {
  id: number
  usuarioId: number
  pessoaFisica: PessoaFisica
  pessoaJuridica: PessoaJuridica
}

export interface Conta {
  id: number
  idContaDock: number
  produto: Produto
  pessoa: Pessoa
  cartoes: []
  ativo: boolean
  senha: string
}

export interface TransferenciaP2P {
  id: number
  tipo: string
  contaOrigem: Conta
  contaDestino: Conta
  valor: number
  descricao: string
  detalhe: string
  uuidTransacao: string
  codigoTransacaoDock: string
  dataTransacaoDock: Date
  idEmissorDock: number
  idAjusteOrigemDock: number
  idAjusteDestinoDock: number
  codigoHttp: number
  mensagemErro: string
}

export interface TransferenciaTEDStatus {
  id: number
  status: string
  codigoDock: string
  statusDock: string
  sucessoDock: boolean
  mensagem: string
}

export interface Banco {
  id: number
  ispb: string
  codigo: string
  nome: string
  nomeReduzido: string
  url: string
  ativo: boolean
}

export interface TransferenciaTED {
  id: number
  transferenciaTEDStatus: TransferenciaTEDStatus
  contaOrigem: Conta
  bancoDestino: Banco
  agenciaNumeroDestino: string
  agenciaDigitoDestino: string
  contaNumeroDestino: string
  contaDigitoDestino: string
  contaTipoDestino: string
  nomeBeneficiarioDestino: string
  documentoDestino: string
  valor: number
  descricao: string
  uuidTransacaoDock: string
  codigoTransacaoDock: string
  dataTransacaoDock: string
  idEmissorDock: number
  codigoSubEmissorDock: string
  idAjusteDock: number
  codigoTarifaDock: string
}

export enum ETipoTransacaoPagamento {
  BOLETO_PAGAMENTO = '1',
  BOLETO_DEPOSITO = '2',
}

export interface TransacaoPagamentoStatus {
  id: number
  descricao: string
  codigo: string
}

export interface TransacaoPagamento {
  id: number
  codigoTransacao: string
  codigoBarras: string
  favorecido: string
  documentoFavorecido: string
  valor: number
  idUnicoDock: string
  tipo: ETipoTransacaoPagamento
  dataVencimento: Date
  conta: Conta
  transacaoPagamentoStatus: TransacaoPagamentoStatus
  valorOriginal?: number
  valorDesconto?: number
  valorMulta?: number
  valorJuros?: number
  idEventoAjuste: number
}

export interface RecargaCelularOperadoraDock {
  id: number
  descricao: string
  codigo: string
}

export interface RecargaCelularStatus {
  id: number
  descricao: string
  codigo: string
}

export interface RecargaCelular {
  id: number
  ddd: string
  telefone: string
  operadora: RecargaCelularOperadoraDock
  valor: number
  amountKeyDock: number
  idAjusteDock: number
  codigoTransacaoDock: string
  conta: Conta
  idOrdemDock: string
  recargaCelularStatus: RecargaCelularStatus
  ativo: boolean
}

export enum EExtracaDadoStatus {
  SUCESSO = 'SUCESSO',
  AGUARDANDO = 'AGUARDANDO',
  EM_PROCESSAMENTO = 'EM_PROCESSAMENTO',
  FALHA = 'FALHA',
}

export interface ExtracaoDado {
  id: number
  ticket: string
  conta: Conta
  dataInicioSolicitacao: Date
  dataFimSolicitacao: Date
  idsMongo: string
  sucesso: boolean
  idDocumento?: string
  idDocumentoPDF?: string
  situacao: EExtracaDadoStatus
}

export interface IComprovanteExtrato {
  id: number
  contaOrigem: Conta
  idDocumento?: string
  idDocumentoPDF?: string
  transferenciaP2P?: TransferenciaP2P
  transferenciaTED?: TransferenciaTED
  transacaoPagamento?: TransacaoPagamento
  recargaCelular?: RecargaCelular
  extracaoDado?: ExtracaoDado
  dataCriacao: Date
  dataAlteracao: Date
}

export default class IComprovantesExtratoResponse {
  from: number
  to: number
  per_page: number
  total: number
  current_page: number
  prev_page?: number | null
  next_page?: number | null
  data: IComprovanteExtrato[]
}
